const policyRenewalsListFormatter = (data, dataKey) => {
  
  const dataSet = {}
  dataSet[dataKey] = data?.data||data;
  console.log(dataSet,  "===========")
  return dataSet;
};

  export default policyRenewalsListFormatter;
  